// extracted by mini-css-extract-plugin
export default {"r_l":"_444d0c203b _3767045572","t":"_9125019518"};